import React from 'react'
import './Email.scss'

const Email = () => {
    return (
        <div>
            <a href = "mailto: kumarsuman4886@gmail.com">
                <button className="Emm"> Email Me</button>
                </a>
        </div>
    )
}

export default Email
